export const CURRENCY_CODE = 'GTQ';

export const CURRENCY_LOCALE = 'es-GT';

const CURRENCY_SYMBOL = 'Q';

const CURRENCY_FORMATTER = new Intl.NumberFormat(CURRENCY_LOCALE, {
  style: 'currency',
  currency: CURRENCY_CODE,
  currencyDisplay: 'narrowSymbol',
  minimumFractionDigits: 2,
});

/**
 * Formats a numeric string as Guatemalan Quetzales with a deterministic Q symbol.
 * Returns the raw value when it cannot be parsed.
 */
export function formatCurrency(val: string | number): string {
  const num = Number.parseFloat(String(val));
  if (Number.isNaN(num)) return String(val);
  return CURRENCY_FORMATTER.formatToParts(num)
    .map((part) => (part.type === 'currency' ? CURRENCY_SYMBOL : part.value))
    .join('');
}

/**
 * Returns the fixed presentation symbol for the internal GTQ currency code.
 */
export function getCurrencySymbol(): string {
  return CURRENCY_SYMBOL;
}
